import { Button, Card, SectionSubtitle, SectionTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { JoinEducatorPageProps } from './types';

export * from './types';

export const JoinEducatorPage: FC<JoinEducatorPageProps> = (props) => {
  const { translate } = useTranslation();
  const { onSignupClick } = props;

  return (
    <Styled.Wrapper>
      <Card size="small">
        <SectionTitle>{translate('joinPro.EDUCATOR.title')}</SectionTitle>
        <SectionSubtitle>{translate('joinPro.EDUCATOR.subtitle')}</SectionSubtitle>
        <Styled.SignupButtonWrapper>
          <Button color="blue" type="submit" onClick={onSignupClick}>
            {translate('common.buttons.register')}
          </Button>
        </Styled.SignupButtonWrapper>
      </Card>
    </Styled.Wrapper>
  );
};
